import * as GAME from 'vibegame';
import { Transform } from 'vibegame/transforms';
import { NeuralNetwork, NeuralNetworkLayer } from '@blog-components/plugins';
import { TextGeneration } from './intro';
import { TextInputManager } from './text-input';
import { TextOutputManager } from './text-output';
import { MultipleOutputsManager } from './multiple-outputs';

export const StageAnimation = GAME.defineComponent({
  cameraX: GAME.Types.f32,
  connections: GAME.Types.f32,
  collapse: GAME.Types.f32,
  textGenT: GAME.Types.f32,
  textInputT: GAME.Types.f32,
  multipleOutputsT: GAME.Types.f32,
  scoresT: GAME.Types.f32,
  averageLineT: GAME.Types.f32,
  sortT: GAME.Types.f32,
  tokenScaleT: GAME.Types.f32,
  flashT: GAME.Types.f32,
});

const stageAnimationQuery = GAME.defineQuery([StageAnimation]);
const layerQuery = GAME.defineQuery([NeuralNetworkLayer]);
const textGenQuery = GAME.defineQuery([TextGeneration]);
const textInputQuery = GAME.defineQuery([TextInputManager]);
const textOutputQuery = GAME.defineQuery([TextOutputManager]);
const multipleOutputsQuery = GAME.defineQuery([MultipleOutputsManager]);

const StageDriverSystem: GAME.System = {
  group: 'simulation',
  update(state) {
    for (const eid of stageAnimationQuery(state.world)) {
      const cameraX = StageAnimation.cameraX[eid];
      const connections = StageAnimation.connections[eid];
      const collapse = StageAnimation.collapse[eid];
      const textGenT = StageAnimation.textGenT[eid];

      const cameraTarget = state.getEntityByName('camera-target');
      if (cameraTarget !== null) {
        Transform.posX[cameraTarget] = cameraX;
      }

      const network = state.getEntityByName('llm');
      if (network !== null) {
        NeuralNetwork.connections[network] = connections;
      }

      for (const layerEid of layerQuery(state.world)) {
        NeuralNetworkLayer.collapse[layerEid] = collapse;
      }

      for (const textEid of textGenQuery(state.world)) {
        TextGeneration.t[textEid] = textGenT;
      }

      const textInputT = StageAnimation.textInputT[eid];
      for (const inputEid of textInputQuery(state.world)) {
        TextInputManager.t[inputEid] = textInputT;
      }

      const multipleOutputsT = StageAnimation.multipleOutputsT[eid];
      for (const outputEid of multipleOutputsQuery(state.world)) {
        MultipleOutputsManager.t[outputEid] = multipleOutputsT;
      }

      const scoresT = StageAnimation.scoresT[eid];
      for (const outputEid of multipleOutputsQuery(state.world)) {
        MultipleOutputsManager.scoresT[outputEid] = scoresT;
      }

      const averageLineT = StageAnimation.averageLineT[eid];
      for (const outputEid of multipleOutputsQuery(state.world)) {
        MultipleOutputsManager.averageLineT[outputEid] = averageLineT;
      }

      const sortT = StageAnimation.sortT[eid];
      for (const outputEid of multipleOutputsQuery(state.world)) {
        MultipleOutputsManager.sortT[outputEid] = sortT;
      }

      const tokenScaleT = StageAnimation.tokenScaleT[eid];
      for (const outputEid of textOutputQuery(state.world)) {
        TextOutputManager.tokenScaleT[outputEid] = tokenScaleT;
      }

      const flashT = StageAnimation.flashT[eid];
      for (const outputEid of textOutputQuery(state.world)) {
        TextOutputManager.flashT[outputEid] = flashT;
      }
    }
  },
};

export const StageAnimationPlugin: GAME.Plugin = {
  components: { StageAnimation },
  systems: [StageDriverSystem],
  config: {
    defaults: {
      'stage-animation': {
        cameraX: -50,
        connections: 0,
        collapse: 0,
        textGenT: 0,
        textInputT: 0,
        multipleOutputsT: 0,
        scoresT: 0,
        averageLineT: 0,
        sortT: 0,
        tokenScaleT: 0,
        flashT: 0,
      },
    },
  },
};
